import React from 'react'

import { AppUrls } from 'common/AppUrls'
import { ReactComponent as AccountIcon } from 'assets/svg/settings/account.svg'
import { ReactComponent as SoundIcon } from 'assets/svg/settings/sound.svg'
import { ReactComponent as CallPreferencesIcon } from 'assets/svg/settings/call_preferences.svg'
import { ReactComponent as HelpIcon } from 'assets/svg/settings/help.svg'
import { ReactComponent as AboutIcon } from 'assets/svg/settings/about.svg'
import { ReactComponent as LogoutIcon } from 'assets/svg/settings/logout.svg'
import { ReactComponent as IntegrationIcon } from 'assets/svg/settings/integration.svg'
import { WhitelabelConfig } from 'hooks'

export const SettingsPages = [
    {
        id: 0,
        name: 'account',
        icon: <AccountIcon width={20} height={20} />,
        url: AppUrls.account
    },
    {
        id: 1,
        name: 'sound_and_devices',
        icon: <SoundIcon width={20} height={20} />,
        url: AppUrls.soundAndDevices
    },
    {
        id: 2,
        name: 'call_preferences',
        icon: <CallPreferencesIcon width={20} height={20} />,
        url: AppUrls.callPreferences
    },
    {
        id: 3,
        name: 'help',
        icon: <HelpIcon width={20} height={20} />,
        url: AppUrls.help,
        disabled: WhitelabelConfig.settingsHelpDisabled
    },
    {
        id: 4,
        name: 'about',
        icon: <AboutIcon width={20} height={20} />,
        url: AppUrls.about,
        disabled: WhitelabelConfig.settingsAboutDisabled
    },
    {
        id: 5,
        name: 'integration',
        icon: <IntegrationIcon width={20} height={20} />,
        url: AppUrls.integration,
        disabled: WhitelabelConfig.settingsIntegrationDisabled
    },
    {
        id: 6,
        name: 'logout',
        icon: <LogoutIcon width={20} height={20} />,
        url: AppUrls.logout
    }
]
